import formatTranslations from './formatTranslations'

export default formatTranslations
